import { Chip, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { EmptyState } from '../../components/EmptyState';
import { Panel } from '../../components/Panel';
import { ShipmentsTable } from './ShipmentsTable';
import type { Shipment } from './sample';

/** A "Shipments" tab: the shipments in a table */
export const ShipmentsTabPanel = ({ rows }: { rows: Shipment[] }) => (
  <Panel title="Shipments">
    <ShipmentsTable rows={rows} />
  </Panel>
);

/** A "Communications" tab: one link per shipment, to that shipment's conversations (opening on `party` if given) */
export function ConversationLinksPanel({ ships, party }: { ships: Shipment[]; party?: string }) {
  const query = party ? `?party=${encodeURIComponent(party)}` : '';
  return (
    <Panel title="Communications">
      {ships.length ? (
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', rowGap: 1 }}>
          {ships.map((s) => (
            <Chip
              key={s.srb}
              component={RouterLink}
              to={`/communications/${s.srb}${query}`}
              clickable
              label={`${s.srb} conversations`}
            />
          ))}
        </Stack>
      ) : (
        <EmptyState>No conversations yet.</EmptyState>
      )}
    </Panel>
  );
}
